import { render, staticRenderFns } from "./SystemModal.vue?vue&type=template&id=db8824c6&scoped=true&"
import script from "./SystemModal.vue?vue&type=script&lang=js&"
export * from "./SystemModal.vue?vue&type=script&lang=js&"
import style0 from "./SystemModal.vue?vue&type=style&index=0&id=db8824c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8824c6",
  null
  
)

export default component.exports